import type * as React from 'react';

const MapRouteIcon: React.FC = function() {
  return (
    <svg
      fill={'none'}
      height={24}
      viewBox={'0 0 24 24'}
      width={24}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={'m6.293 5.207 3.5 3.5a1 1 0 0 0 1.665-.42l1.5-5a1 1 0 0 0-1.245-1.245l-5 1.5a1.003 1.003 0 0 0-.42 1.665'}
        fill={'currentColor'}
      />
      <path
        d={'M4.96 8.157c-1.708 1.501-1.952 4.168-.548 5.968 1.414 1.812 3.99 2.107 5.757.658l4.88-4.004a2.11 2.11 0 0 1 3.015.346c.749.96.617 2.4-.293 3.2l-1.043.916c-.409.36-.456.99-.106 1.41s.966.468 1.375.108l1.043-.916c1.708-1.502 1.953-4.166.547-5.968-1.412-1.81-3.992-2.106-5.756-.658l-4.88 4.004a2.11 2.11 0 0 1-3.016-.346c-.747-.958-.616-2.4.293-3.2l.542-.415c.409-.36.46-.99.11-1.41a.964.964 0 0 0-1.38-.11z'}
        fill={'currentColor'}
      />
      <path
        d={'M10 19a3 3 0 1 1 6 0 3 3 0 0 1-6 0'}
        fill={'currentColor'}
      />
    </svg>
  );
};

export default MapRouteIcon;